@if (!isVoid) {
<div class="ppe-widget">
    @if (ppeAssignments && ppeAssignments.length > 0) {
    <div class="ppe-content">
        @for (ppe of ppeAssignments; track trackByIndex($index)) {
        <div class="ppe-item">
            <img [src]="ppe.iconUrl" [alt]="ppe.name || 'PPE'" class="ppe-icon" />
            <div class="ppe-details">
                <div class="ppe-model">{{ ppe.modelName || ppe.name || unknownPpeText }}</div>
                @if (ppe.rating && ppe.ratingTypeName) {
                <div class="ppe-protection-factor">
                    {{ ppe.rating }} ({{ ppe.ratingTypeName }})
                </div>
                }
                @if (ppe.brand) {
                <div class="ppe-brand">{{ brandLabel }}: {{ ppe.brand }}</div>
                }
            </div>
        </div>
        }
    </div>

    @if (maxUseWarning) {
    <div class="max-use-warning">
        <strong>{{ maxUseWarning.message }}</strong>
    </div>
    }
    } @else {
    <div class="ppe-empty">{{ noPpeWornText }}</div>
    }
</div>
}